.error {
  color: var(--color-red-700);

  input {
    border-color: var(--color-red-700);
  }
}

.sizeMiddle {
  font-size: 1rem;
}

.sizeLarge {
  font-size: 1.125rem;
}
